import * as $ from 'jquery';
import * as moment from 'moment';
import * as angular from 'angular';

import {
  Input,
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { DialogService } from 'services/dialog.service';
import { SearchService } from 'services/search.service';
import { SessionService } from 'services/session.service';
import { ProductService } from 'services/product.service';
import { PopulateService } from 'services/populate.service';
import * as startsWith from 'lodash/startsWith'



/**
 * Search base class
 *
 * This class has funcionality shared between all
 * product search types. These components should
 * extend this class to inherit functionality.
 */
export abstract class SearchComponent {
  public GW = (<any>window).GW;
  public laroute = (<any>window).laroute;
  public search: any = {};
  public itinerary: any = {};
  public searchResults: any = {};
  public datePickerOpts: any = {};
  public countries = this.GW.countries;

  @Input() searchTerm: string;
  @Input() searchValue: string;
  @Input() searchRoute: string;
  @Input() submitLabel: string;
  @Input() searchClean: boolean;

  constructor(
    @Inject('$filter') protected $filter,
    @Inject('$scope') protected $scope: ng.IScope,
    @Inject('$rootScope') protected $rootScope: ng.IRootScopeService,
    @Inject('$timeout') protected $timeout: ng.ITimeoutService,
    @Inject('$window') protected $window,
    @Inject('$http') protected $http: ng.IHttpService,
    @Inject(DialogService) protected dialogService: DialogService,
    @Inject(SearchService) protected searchService: SearchService,
    @Inject(SessionService) protected sessionService: SessionService,
    @Inject(ProductService) protected productService: ProductService,
    @Inject(PopulateService) protected populateService: PopulateService,
  ) {
    this.onInit();
  }

  /**
   * Base component init
   */
  onInit() {
    // Fetch saved search from set cookie if it exists
    this.search = this.searchService.getSearch(this.searchClean);

    // Insert new destination row if none
    if (this.search.rows.length === 0) {
      this.searchService.addSearchRow();
    }

    // Get term set through binding if any
    if (this.searchTerm) {
      this.search.rows[0].term = this.searchTerm;
      this.search.rows[0].selected = this.searchValue;
    }

    // Convert search dates if they exist to Moment objects
    this.search.rows = this.search.rows.map((search) => {
      if (search.dates.startDate) {
        search.dates.startDate = moment(search.dates.startDate);
      }

      if (search.dates.endDate) {
        search.dates.endDate = moment(search.dates.endDate);
      }

      return search;
    });

    // Search results state
    this.searchResults = {
      all: null,
      items: [],
      open: false,
      focused: false,
      selected: this.searchValue || null,
      selectedCountryIndex: -1,
    },

    /**
     * Datepicker options
     * @type {Object}
     */
    this.datePickerOpts = {
      autoApply: true,
      minDate: moment(),
      linkedCalendars: true,
      autoUpdateInput: true,
      locale: {
        format: 'MM/DD/YYYY',
      },
    };
  }

  /**
   * Fetch results
   */
  fetchResults(search, param = null) {
    this.searchResults.selectedCountryIndex = -1;
    // Cleans the value of the selected country after user types a different country name.
    search.selected = '';

    if (!search.term) {
      this.searchResults.items = this.searchResults.all;
      return;
    }

    this.searchResults.items = this.$filter('filter')(this.searchResults.all, {
      label: search.term,
    }, (actual, expected) => {
      return startsWith(actual.toLowerCase(), expected.toLowerCase())
    });

    search.open = true;
  }

  /**
   * Search result selected handler
   * @param {Object} search
   * @param {Object} result
   * @param param
   */
  selectResult(search, result, param = null) {
    search.term = result.label;
    search.selected = result.value;
    search.open = false;

    const index = this.search.rows.indexOf(search);

    // Output to hero that the country changed
    this.$scope.$emit('search-change', {
      result: {
        type: search.type,
        value: search.selected,
      },
    });
  }

  /**
   * Clear search
   */
  clearSearch() {
    this.search = this.searchService.resetSearch();
  }

  getRoute(route, params) {
    return this.laroute.route(route, params);
  }

  submitSearch(route) {
    this.searchService.updateSearch(this.search);
    return window.location.assign(route);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/search/search.component.ts